export default __webpack_public_path__ + "cccebacdaa5762782f37f6692a356fb3.svg";